import { MeasurementDataReq } from "./measurement-req";

export class StyleReq {
    id?: number;
    styleData?: string;
    seasonData?: number;
    submitDate?: string;
    measurement?: MeasurementDataReq[];
    constructor(id?: number,
        styleData?: string,
        seasonData?: number,
        submitDate?: string,

        measurement?: MeasurementDataReq[],
    ) {
        this.id = id;
        this.styleData = styleData;
        this.seasonData = seasonData;
        this.submitDate = submitDate;
        this.measurement = measurement;
    }


}